import type { EventType } from '../../types.js'
import { Block } from '../block.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { TextOrExpression_assumeText } from '../../data/text-or-code.js'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'
import { LinkBlock } from '../other/link-block.js'
import {
	type IconBlockFontSet,
	IconBlockFontSets,
} from '../other/icon-block.js'
import { BlockWithPrefixIcon } from '../common/block-with-prefix-icon.js'
import { BlockLinkDefinition } from '../common/block-link-definition.js'

@jsonClass('NavigationItemBlock')
export class NavigationItemBlock extends Block implements BlockWithPrefixIcon {
	@jsonProperty(BlockLinkDefinition)
	@ScreenEditorInput<LinkBlock>({
		order: 1,
		label: '',
		compositionObj: (blocks) => blocks[0].link,
	})
	link: BlockLinkDefinition = new BlockLinkDefinition()

	@jsonProperty(TextOrExpression_assumeText)
	@ScreenEditorInput({
		inputType: 'code',
		order: 2,
		label: 'Prefix icon',
		codeLanguage: 'ts',
		alternativeContentAreaName: 'prefix',
		tsReturnType: () => 'string',
		editorSize: 'singleline',
		isBinding: false,
	})
	prefixIconCode = new TextOrExpression_assumeText('', 'T')

	@jsonProperty(String)
	@ScreenEditorInput({
		inputType: 'dropdown',
		order: 3,
		label: 'Prefix icon style',
		options: Object.entries(IconBlockFontSets),
	})
	prefixIconFontSet: IconBlockFontSet = 'material-icons'

	@jsonProperty(TextOrExpression_assumeText)
	@ScreenEditorInput({
		inputType: 'code',
		order: 4,
		label: 'Content at right side',
		codeLanguage: 'ts',
		alternativeContentAreaName: 'right',
		tsReturnType: () => 'string',
		editorSize: 'singleline',
		isBinding: false,
	})
	rightTextCode = new TextOrExpression_assumeText('', 'T')

	constructor(init: Partial<NavigationItemBlock> = {}) {
		super()
		this.init(init)
	}
	get allowedEventTypes(): EventType[] {
		return [{ name: 'click' }, { name: 'dblclick' }]
	}

	getEditorCategory(): string {
		return 'Screen Structure'
	}

	getPreviewDirection() {
		return 'row' as const
	}

	isBlockWithPrefixIcon(): this is BlockWithPrefixIcon {
		return true
	}

	static createNewForEditor(): Block {
		return new this({
			children: [LinkBlock.createNewForEditor()],
		})
	}
}
